import { render, staticRenderFns } from "./TicketMessageAttentions.vue?vue&type=template&id=50666e3d&scoped=true&"
import script from "./TicketMessageAttentions.vue?vue&type=script&lang=ts&"
export * from "./TicketMessageAttentions.vue?vue&type=script&lang=ts&"
import style0 from "./TicketMessageAttentions.vue?vue&type=style&index=0&id=50666e3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50666e3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50666e3d')) {
      api.createRecord('50666e3d', component.options)
    } else {
      api.reload('50666e3d', component.options)
    }
    module.hot.accept("./TicketMessageAttentions.vue?vue&type=template&id=50666e3d&scoped=true&", function () {
      api.rerender('50666e3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketMessageAttentions.vue"
export default component.exports